export function getWSPLITEEditorType(websiteType) {
  let websiteTypeResult = websiteType;

  if (websiteType === 'WSPLITE') {
    websiteTypeResult = 'whatsapp';
  }

  return websiteTypeResult;
}
